// extracted by mini-css-extract-plugin
export default {"MainSlider_subContainer":"MainSlider_MainSlider_subContainer__7clTM"};